module.exports = __webpack_public_path__ + "audio-b3da47c5bd4c.m4a";